// removed by extract-text-webpack-plugin
module.exports = {"CategoriesContainer":"_2WhpqpfrrdBbaWPWUK2gJ_","CategoriesItem":"_24z0Bh1Nq4-Wy155YdyOU4","CategoryTitle":"_2RswWCfRRUm4pR8jn6Ugjy","NavButton":"_2RSibN2-OFhL3d7XAqg4ih","NumberUnread":"_2-m0CN4QhrjHYXXqTR1b4y","Icon":"vb0mDVDB5apTkx5hI94zH"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Categories/style.css
// module id = 2029
// module chunks = 0